import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <div className="text-white text-lg font-light">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Redirect clients to their dashboard
  if (user.role === 'client' && location.pathname === '/dashboard') {
    return <Navigate to="/client-dashboard" replace />;
  }

  // Redirect trainers from client dashboard to trainer dashboard
  if (user.role !== 'client' && ['/client-dashboard', '/client-panel'].includes(location.pathname)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};